import type { z } from 'zod'

export const isZodError = (error: unknown): error is z.ZodError =>
  error
    ? typeof error === 'object' &&
      'issues' in error &&
      Array.isArray(error?.issues)
    : false
